export default __webpack_public_path__ + "static/media/tool-icon-shirt-black-10.de793c71.svg";